import React from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import styled, { css } from "styled-components";

const Container = styled.div`
  min-width: 100%;
  max-width: 100%;
  margin-bottom: 33px;
`;
const Title = styled.h1`
  font-weight: bold;
  font-size: 18px;
  line-height: 47px;
  color: #7b848d;
  ${({ theme: { mobile } }) =>
    mobile &&
    css`
      font-size: 16px;
    `}
`;
const TableHeader = styled.thead`
  height: 42px;
`;
const TableHeaderRow = styled.tr`
  vertical-align: middle;
  border-top: 1px solid #ecedf1;
  border-bottom: 1px solid #ecedf1;
`;
const TableHeaderCell = styled.th`
  text-align: center;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 15px;
  color: #7b848d;
  white-space: nowrap;
  ${({ mwidth }) => (mwidth ? `max-width: ${mwidth}px !important` : "")}
`;
const TableHeaderCellLeft = styled(TableHeaderCell)`
  text-align: left;
`;
const TableBody = styled.tbody`
  border: none !important;
`;
const TableBodyRow = styled(TableHeaderRow)`
  border-top: none;
  height: 40px;
  ${({ index }) => (index % 2 === 0 ? "background-color: #FAFAFF;" : "")}
`;
const TableBodyCell = styled.td`
  text-align: center;
  font-style: normal;
  font-size: 12px;
  white-space: nowrap;
  color: ${({ color }) => color || "#394149"};
`;
const TableBodyCellLeft = styled(TableBodyCell)`
  text-align: left;
`;

function TableRow({ index, code, type, descriptionText, date, number }) {
  return (
    <TableBodyRow index={index}>
      <TableBodyCellLeft>{code}</TableBodyCellLeft>
      <TableBodyCellLeft>{type}</TableBodyCellLeft>
      <TableBodyCellLeft>{descriptionText}</TableBodyCellLeft>
      <TableBodyCellLeft>{date}</TableBodyCellLeft>
      <TableBodyCellLeft>{number}</TableBodyCellLeft>
    </TableBodyRow>
  );
}

TableRow.propTypes = {
  index: PropTypes.number,
  code: PropTypes.string,
  type: PropTypes.string,
  descriptionText: PropTypes.string,
  date: PropTypes.string,
  number: PropTypes.number,
};

function EventListDesktop({ events }) {
  if (!events) return null;

  return (
    <Container>
      <Title>Events</Title>
      <Table responsive>
        <TableHeader>
          <TableHeaderRow>
            <TableHeaderCellLeft>CODE</TableHeaderCellLeft>
            <TableHeaderCellLeft>TYPE</TableHeaderCellLeft>
            <TableHeaderCellLeft>DESCRIPTION</TableHeaderCellLeft>
            <TableHeaderCellLeft>DATE</TableHeaderCellLeft>
            <TableHeaderCellLeft>NUMBER</TableHeaderCellLeft>
          </TableHeaderRow>
        </TableHeader>
        <TableBody>
          {events.map((eventInfo, idx) => (
            <TableRow key={idx} index={idx} {...eventInfo} />
          ))}
        </TableBody>
      </Table>
    </Container>
  );
}

EventListDesktop.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object),
};

export default EventListDesktop;
